import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@cimpress/react-components';
import ErrorText from './Shared/ErrorText';

class FormTextField extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    input: PropTypes.object.isRequired,
    label: PropTypes.string.isRequired,
    meta: PropTypes.object.isRequired,
    inputStyle: PropTypes.object,
    type: PropTypes.string
  };

  render() {
    const { className, name, input, inputStyle, type, label, meta } = this.props;

    return (
      <div className={className}>
        <TextField {...input} name={name} label={label} inputStyle={inputStyle} type={type} />
        {meta.touched && meta.error && <ErrorText text={meta.error} />}
      </div>
    );
  }
}

export default FormTextField;
